<template>
    <div>
        <Breadcrumbs main="Shops" title="Shop List"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">

              <div class="col-md-12">
                <div class="card">
                    <div hidden class="card-header">
                      <h5>Zero Configuration</h5>
                      <span>DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.</span><span>Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</span>
                    </div>

                    <div class="card-body">
                      <b-row>
                          <b-col md="4">

                              <b-input-group label-cols="" class="datatable-">
                                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                  <b-input-group-append>
                                      <b-button id="default-secondary" variant="secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                  </b-input-group-append>
                              </b-input-group>

                          </b-col>

                          <!-- <b-col md="3">
                            <b-form-group hidden label-cols="4" content-cols="6"  label="Selection" class="mb-0 datatable-select">
                                <b-form-select
                                  id="table-select-mode-select"
                                  v-model="selectMode"
                                  :options="modes"
                                  class="mb-3"
                                ></b-form-select>
                              </b-form-group>
                          </b-col> -->

                          <b-col md="4">
                              <b-form-group label-cols="4" content-cols="4" label="Per page" class="mb-0 datatable-select">
                                  <b-form-select style="width:100px" v-model="perPage" :options="pageOptions"></b-form-select>
                              </b-form-group>
                          </b-col>

                          <b-col md="4">
                            <div class="text-right">
                              <div class="form-group mb-0 mr-0"></div>
                              <a class="btn btn-primary mr-3 mb-2" v-b-modal.patient >
                                
                                <i class="icon-shopping-car"> </i> New Shop</a
                              >
                              <a hidden class="btn btn-outline-primary mr-3 mb-2" v-b-modal.request >
                                
                                <i class="icon-user"> </i> Patient Request</a
                              >
                              <a  class="btn btn-outline-primary mr-3 " v-b-modal.importPatient >
                                <i class="icon-cloud-up"> </i> Import </a
                              >
                            </div>

                            <b-modal id="product" size="lg" ref="productModal" title="Add Products" ok-title="Done" class="theme-modal">
                                <template #modal-header>
                                    <h5>{{ 'View Products : '+viewProduct }} <span v-if="editProduct">{{ ': Edit Product : '+editProduct }}</span> </h5>
                                    
                                </template>

                                <form id="productForm" @submit.stop.prevent="checkSubmit" class="p-2 px-3">
                                  
                                    <!-- <figure v-if="productFiles" class="b-image-wrapper image is-16by9 m-1"> -->
                                        <!-- <b-img
                                            rounded
                                            :src="pros"
                                            style="width:100%"
                                            ratio="16by9"
                                        >
                                        </b-img> -->
                                    <div v-if="productFiles.length > 0" >
                                        <b-carousel
                                          id="carousel-1"
                                          v-model="slide"
                                          :interval="5000"
                                          controls
                                          indicators
                                          img-width="100%"
                                          @sliding-start="onSlideStart"
                                          @sliding-end="onSlideEnd"
                                        >
                                          <!-- Text slides with image -->
                                           <!--  -->
                                          <b-carousel-slide 
                                            v-for="img in productFiles" :key="img.lastModified"
                                          > 
                                          <template #img>
                                            <b-img
                                            :key="img.lastModified"
                                              class="d-block img-fluid"
                                              style="width:100%"
                                              :src="window.URL.createObjectURL(img)"
                                              alt="image slot"
                                              ratio="16by9"
                                            ></b-img>
                                          </template>
                                        </b-carousel-slide>
                                          
                                        </b-carousel>

                                      </div>
                                      <div v-else-if="product.images.length > 0">
                                        <b-carousel
                                          id="carousel-1"
                                          v-model="slide"
                                          :interval="5000"
                                          controls
                                          indicators
                                          img-width="100%"
                                          @sliding-start="onSlideStart"
                                          @sliding-end="onSlideEnd"
                                        >
                                          <!-- Text slides with image -->
                                           <!--  -->
                                          <b-carousel-slide 
                                            v-for="img in product.images" :key="img"
                                          > 
                                          <template #img>
                                            <b-img
                                            :key="img"
                                              class="d-block img-fluid"
                                              style="width:100%"
                                              :src="img"
                                              alt="image slot"
                                              ratio="16by9"
                                            ></b-img>
                                          </template>
                                        </b-carousel-slide>
                                          
                                        </b-carousel>
                                      </div>

                                    <!-- </figure> -->


                                    <div class="row form-group mt-2">
                                        <div class="col-sm-4 col-12">
                                            <label class="col-form-label" type="text" for="recipient-name">Product/Service: </label>
                                                <b-form-input 
                                                autocomplete="0"
                                                autofocus 
                                                required 
                                                v-model="product.product"
                                                placeholder="Name">
                                            </b-form-input>
                                            
                                        </div>
                                        <div class="col-sm-2 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name"> Image: <span class="txt-primary"></span></label>
                                            <b-form-file accept="image/jpeg, image/png" multiple v-model="productFiles" ></b-form-file>
                                        </div>
                                        <div class="col-sm-2 col-6">
                                          <label class="col-form-label" for="recipient-name">Type: 
                                            <!-- <span class="badge badge-primary" @click="switchType"> swap </span> -->
                                          </label>
                                            <b-form-select required v-model="product.type" :options="productType"></b-form-select>
                                            <!-- <b-form-input 
                                            v-else
                                            v-model="product.type" 
                                            placeholder="Type ">
                                            </b-form-input> -->
                                        </div>
                                        <div class="col-sm-4 col-12">
                                            <label class="col-form-label" type="text" for="recipient-name">Category: </label>
                                            <b-form-select required v-model="product.category" :options="productCategory"></b-form-select>
                                            <!-- <b-form-input 
                                                v-else
                                                v-model="product.category"
                                                placeholder="Category">
                                            </b-form-input> -->
                                        </div>
                                    </div>
                                    <div class="row form-group mt-2">
                                        
                                        <div class="col-sm-3 col-6">
                                          <label class="col-form-label" for="recipient-name">Tags: <span class="txt-primary"></span></label>
                                          <b-form-input 
                                            required 
                                            v-model="product.tags" 
                                            placeholder="Tags ">
                                            </b-form-input>
                                        </div>

                                        <div class="col-sm-2 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name">Price: <span class="txt-primary">{{ product.price && product.discount ? "("+ (product.price * ((100 - parseFloat(product.discount))/100)).toFixed(2)+")" : '' }} </span> </label>
                                            <b-form-input 
                                                type="number"
                                                required 
                                                step="0.01"
                                                v-model="product.price"
                                                @input="genDiscount"
                                                placeholder="Price">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-2 col-6">
                                          <label class="col-form-label" for="recipient-name">Discount: </label>
                                          <b-form-input 
                                            required 
                                            type="number"
                                            step="0.0001"
                                            @input="checkDiscount"
                                            v-model="product.discount" 
                                            placeholder="Discount % ">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-2 col-6">
                                          <label class="col-form-label" for="recipient-name">Discounted: </label>
                                          <b-form-input 
                                            required 
                                            type="number"
                                            step="0.0001"
                                            @input="genDiscount"
                                            v-model="product.discounted" 
                                            placeholder="Price ">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-3 col-6">
                                          <label class="col-form-label" for="recipient-name">Offer Type: </label>
                                          <b-form-select required v-model="product.offerType" :options="offerTypes"></b-form-select> 
                                        </div>
                                    </div>
                                    <div class="row form-group mt-2">
                                      <div class="col-lg-6 col-sm-6 col-6">
                                        <label class="col-form-label" for="">Start Date</label>
                                        <b-form-datepicker
                                              :disabled="startDisabled"
                                              v-model="product.start" 
                                              placeholder="Start Date">
                                          </b-form-datepicker>
                                      </div>
                                      <div class="col-lg-6 col-sm-6 col-6">
                                        <label class="col-form-label" for="">End Date</label>
                                        <b-form-datepicker
                                              :disabled="endDisabled"
                                              v-model="product.end" 
                                              placeholder="End Date">
                                          </b-form-datepicker>
                                      </div>
                                      
                                      
                                    </div>
                                    <div  class="row form-group mt-2">
                                        <div class="col-lg-3 col-sm-4 mt-2 col-3">
                                          <label class="col-form-label" for="recipient-name">Exipry:</label>
                                          <!-- <b-form-select required v-model="Shop.active" :options="statusOptions"></b-form-select> -->
                                          <b-form-radio-group required :options="statusOptions" v-model="expiry" value-field="value" text-field="item">
                                          </b-form-radio-group>
                                        </div>
                                        <div class="col-lg-3 col-sm-4 mt-2  col-3">
                                          <label class="col-form-label" for="recipient-name">Visible:</label>
                                          <!-- <b-form-select required v-model="Shop.active" :options="statusOptions"></b-form-select> -->
                                          <b-form-radio-group required :options="statusOptions" v-model="product.visible" value-field="value" text-field="item">
                                          </b-form-radio-group>
                                        </div>
                                        <div class="col-lg-3 col-sm-4 mt-2 col-3">
                                          <label class="col-form-label" for="recipient-name">Limited Edition:</label>
                                          <!-- <b-form-select required v-model="Shop.active" :options="statusOptions"></b-form-select> -->
                                          <b-form-radio-group required :options="statusOptions" v-model="product.limited" value-field="value" text-field="item">
                                          </b-form-radio-group>
                                        </div>
                                        <div class="col-lg-3 col-sm-4 mt-2 col-3">
                                          <label class="col-form-label" for="recipient-name">Available (Stock):</label>
                                          <!-- <b-form-select required v-model="Shop.active" :options="statusOptions"></b-form-select> -->
                                          <b-form-radio-group required :options="statusOptions" v-model="product.available" value-field="value" text-field="item">
                                          </b-form-radio-group>
                                        </div>
                                    </div>
                                    <div class="form-group row mt-2">
                                      <div class="col-sm-6 col-12">
                                        <label class="col-form-label" for="recipient-name">Details: </label>
                                        <b-form-input 
                                            required 
                                            v-model="product.details" 
                                            class="mb-1"
                                            placeholder="Details ">
                                        </b-form-input>
                                        <!-- <label class="col-form-label" for="recipient-name">Shipping: </label><br>
                                        <b-form-input 
                                            style="width: 23%;display: inline;" 
                                            v-model="product.dimensions.length" 
                                            placeholder="Length ">
                                        </b-form-input>
                                        <b-form-input 
                                            class="mx-2"
                                            style="width: 23%;display: inline;" 
                                            v-model="product.dimensions.width" 
                                            placeholder="Width ">
                                        </b-form-input>
                                        <b-form-input 
                                            style="width: 23%;display: inline;" 
                                            v-model="product.dimensions.height" 
                                            placeholder="Height ">
                                        </b-form-input>
                                        <b-form-input 
                                        
                                            class="ml-2"
                                            style="width: 23%;display: inline;" 
                                            v-model="product.weight" 
                                            placeholder="Weight ">
                                        </b-form-input> -->
                                      </div>
                                      <div class="col-sm-6 col-12">
                                        <label class="col-form-label" for="">Description</label>
                                        <b-form-textarea
                                            id="textarea"
                                            v-model="product.description"
                                            placeholder="Enter description..."
                                            rows="4"
                                        ></b-form-textarea>
                                      </div>
                                    </div>
                                    <b-button block  type="submit" variant="primary">Submit</b-button>
                                </form>
                                <div class="px-3 py-2">
                                    <b-table
                                        show-empty
                                        ref="productTable"
                                        :items="allProducts"
                                        :fields="productfields"
                                        :sort-by.sync="sortProductBy"
                                        :current-page="currentProductPage"
                                        :per-page="perProductPage"
                                    >

                                        <template #cell(images)="row">

                                            <a :href="row.item.image" target="_blank">
                                                        <b-img
                                                            rounded
                                                            :src="row.item.images[0]"
                                                            style="width:50px;height:50px;object-fit:cover"
                                                        >
                                                        </b-img>
                                                    </a>
                                        </template>
                                        <template #cell(product)="row">
                                            {{ row.item.product }}
                                            <span class="txt-primary">( {{ row.item.category }} )</span>
                                            <span class="badge badge-primary ml-2" v-if="row.item
                                            .discount > 0"> {{ row.item.discount }} % off</span>
                                            <br><span style="font-size:0.85rem;color:grey" class="txt-grey">{{ row.item.details }}</span>
                                        </template>

                                        <template #cell(type)="row">
                                          <p class="txt-primary mb-1">
                                            <b> {{ row.item.type }} </b>
                                          </p>
                                          <div v-if="row.item.offerType" v-b-tooltip.hover  :class="`btn ${ (row.item.offerType == 'Discount' ? 'btn-primary' : row.item.offerType == 'Coupon' ? 'btn-warning text-dark' : row.item.offerType == 'Gift with Purchase' ? 'btn-info' : row.item.offerType == 'Promo' ? 'btn-danger' : 'btn-success') } btn-xs  mr-3`">
                                                      {{ (row.item.offerType) }}
                                                  </div>
                                        </template>
                                        

                                        <template #cell(price)="row">

                                            <span v-if="row.item.discount !== 0" style="font-weight:500" class="mr-1 txt-primary">
                                                <span class="mr-1 txt-dark" style="text-decoration:line-through;font-weight:400"> GH₵{{ formatPrice(row.item.price) }} </span>
                                                 GH₵{{ formatPrice( getDiscount(row.item.price, row.item.discount) ) }} 
                                            </span>
                                            <span class="txt-primary" style="font-weight:500" v-else>GH₵{{ formatPrice(row.item.price) }}</span>
                                            
                                        </template>

                                        <template #cell(action)="row">

                                        <b-button variant="primary" @click="editproduct(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-pencil"> </i>  </b-button>
                                        <b-button variant="danger" @click="delproduct(row.item)" class="px-3" size="sm"> <i class="icon-trash"> </i> </b-button>

                                        </template>
                                    </b-table>
                                    <p class="px-3">{{ allProducts.length }} items </p>

                                    <b-col md="6" class="my-1">
                                        <b-pagination
                                        v-model="currentProductPage"
                                        :total-rows="totalProductRows"
                                        :per-page="perProductPage"
                                        class="my-0"
                                        ></b-pagination>
                                    </b-col>
                                </div>
                            </b-modal>

                            <!-- patient form -->
                            <b-modal id="patient" ref="ShopModal" v-on:hide="resetShop()" :title="`${( editShop ? 'Edit Shop : '+editShop : 'Create New Shop ')} `" ok-title="Done" class="theme-modal">

                              <template #modal-header>
                                <h5>{{ editShop ? 'Edit Shop : '+editShop : 'Create New Shop ' }} <b-button v-if="!(editShop)" pill size="xs" type="reset" @click="resetShop()" variant="outline-danger">Reset</b-button></h5>
                                
                              </template>
                              <!-- {{ patient }} -->
                              <p class="px-3">Kindly fill form to add a <b>Shop</b>, add products <a class="badge badge-primary badge-md" v-b-modal.product> products <b>({{ allProducts.length ? allProducts.length : 0 }})</b> </a>
                               </p>
                              <!-- <p><b>#NB:</b> A 4-Digit <b>OTP verify Code</b> will be sent to <b>Patient's Tel.</b> </p> -->


                                <form id="ShopForm" @submit.stop.prevent="submitShop" class="p-2 px-3">
                                    
                                    
                                    <figure v-if="dropFile || editShop" class="b-image-wrapper image is-16by9 m-1">
                                        <b-img
                                            rounded
                                            :src="img"
                                            style="width:100%"
                                            ratio="16by9"
                                        >
                                        </b-img>
                                    </figure>

                                    <div class="row form-group mt-2">
                                        <div class="col-sm-6 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name">Shop: <span class="txt-primary">( Name )</span></label>
                                                <b-form-input 
                                                autocomplete="0"
                                                autofocus 
                                                required 
                                                v-model="Shop.name"
                                                placeholder="Shop Name">
                                            </b-form-input>
                                            
                                        </div>
                                        <div v-if="uploadImg" class="col-sm-6 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name">Cover/Logo image: <a class="badge badge-primary" @click="switchUploadImg()">switch</a></label>
                                            <b-form-file 
                                                :required="editShop ? false : true"
                                                accept="image/jpeg, image/png" 
                                                v-model="dropFile" 
                                            ></b-form-file>
                                        </div>
                                        <div v-else class="col-sm-6 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name">Cover/Logo image: <a class="badge badge-primary" @click="switchUploadImg()">switch</a></label>
                                            <b-form-input
                                                v-model="Shop.logo" 
                                                placeholder="Cover/Logo Link"
                                            ></b-form-input>
                                        </div>
                                    </div>

                                    <div class="row form-group mt-2">
                                        <!-- <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Patient No:</label>
                                          <b-form-input required v-model="patient.no" type="text" placeholder="Patient No"></b-form-input>
                                        </div> -->
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Type: <span class="txt-primary">( Mini mart, Cloth store )</span></label>
                                          <b-form-input 
                                            required 
                                            v-model="Shop.type" 
                                            placeholder="Type ">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-6 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name">Categories: <span class="txt-primary">( Dry food, Fresh )</span></label>
                                            <b-form-input 
                                                required 
                                                v-model="Shop.cat"
                                                placeholder="Categories">
                                            </b-form-input>
                                        </div>
                                    </div>

                                    
                                    
                                    <div class="row form-group mt-2">
                                        <div class="col-sm-3 col-4">
                                            <label class="col-form-label" type="text" for="recipient-name">CountryCode<span class="txt-primary"></span></label><br>
                                            <vue-country-code
                                                class=" p-1"
                                                
                                                @onSelect="onSelect"
                                                :enabledCountryCode="true"
                                                :preferredCountries="[ 'us', 'gb', 'gh','ng','ke']"
                                                >
                                            </vue-country-code>
                                        </div>
                                        <div class="col-sm-5 col-5">
                                            <label class="col-form-label" type="text" for="recipient-name">Country</label>
                                            <b-form-input 
                                                autocomplete="0"
                                                required 
                                                v-model="Shop.country.name"
                                                placeholder="Name">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-4 col-3">
                                            <label class="col-form-label" type="text" for="recipient-name">Currency</label>
                                            <b-form-input 
                                                autocomplete="0"
                                                required 
                                                v-model="Shop.country.currency"
                                                placeholder="Currency">
                                            </b-form-input>
                                        </div>
                                    </div>
                                      

                                    <div class="row form-group mt-2">
                                        <!-- <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Patient No:</label>
                                          <b-form-input required v-model="patient.no" type="text" placeholder="Patient No"></b-form-input>
                                        </div> -->
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Contact: <a class="badge badge-primary" @click="sameAsWhatsapp()"> Same </a></label>
                                          <b-form-input 
                                            required 
                                            autocomplete="off"
                                            v-model="Shop.phone.tel" 
                                            type="tel" 
                                            placeholder="Business Contact ">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Whatsapp: </label>
                                          <b-form-input 
                                            autocomplete="off"
                                            v-model="Shop.whatsapp.tel" 
                                            type="tel" 
                                            placeholder="Whatsapp Contact ">
                                            </b-form-input>
                                        </div>
                                    </div>

                                    <!-- <b-form-group style="border:0" label="Individual radios" v-slot="{ ariaDescribedby }"> -->
                                      
                                    <!-- </b-form-group> -->

                                    <div class="row ">
                                      <div class="col-sm-6 col-6">
                                        <label class="col-form-label" for="recipient-name">Email: <span class="txt-primary">( For login )</span><span class="txt-primary">  </span></label>
                                        <b-form-input 
                                          required
                                          v-model="Shop.email" 
                                          autocomplete="off"
                                          type="email" 
                                          placeholder="Business Email">
                                        </b-form-input>
                                      </div>
                                      <div class="col-sm-6 col-6">
                                        <label class="col-form-label" for="recipient-name">Password:</label>
                                        <b-form-input :required="editShop ? false : true" v-model="Shop.password" type="password" text-field="item" placeholder="Password">
                                        </b-form-input>
                                      </div>
                                    </div>
                                    
                                    
                                    <div class="row form-group mt-2">
                                      <div class="col-sm-6 col-6">
                                        <label class="col-form-label" for="recipient-name">Website: <span class="txt-primary">( example.com )</span><span class="txt-primary">  </span></label>
                                        <b-form-input 
                                          v-model="Shop.website" 
                                          autocomplete="off"
                                          type="text" 
                                          placeholder="Business Website">
                                        </b-form-input>
                                      </div>
                                      <div class="col-sm-6 col-6">
                                        <label class="col-form-label" for="recipient-name">Active:</label>
                                        <!-- <b-form-select required v-model="Shop.active" :options="statusOptions"></b-form-select> -->
                                        <b-form-radio-group required :options="statusOptions" v-model="Shop.active" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                      <!-- <div class="col-sm-6 col-6">
                                        <label class="col-form-label p-2 " for="recipient-name">Free Delivery:</label>
                                        <b-form-radio-group required :options="freedeliveryOptions" v-model="Shop.freeDelivery" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div> -->
                                    </div>

                                    <div class="row form-group mt-2">
                                      <div class="col-sm-6 col-6">
                                        <label class="col-form-label" type="text" for="recipient-name">Location:  <a target="_blank" class="badge badge-primary" href="https://www.google.com/maps"> Google maps </a> </label>
                                        <b-form-input 
                                        autocomplete="0"
                                        required 
                                        v-model="Shop.locationName"
                                        placeholder="Business Location">
                                        </b-form-input>
                                      </div>
                                      <div class="col-sm-6 col-6">
                                        <label class="col-form-label" for="recipient-name">Location: <span class="txt-primary"> ( Lat, Lng ) </span></label>
                                        <b-form-input required v-model="Shop.loc" text-field="item" placeholder="Longitude">
                                        </b-form-input>
                                      </div>
                                      
                                    </div>

                                    <!-- <label class="col-form-label" for="message-text">Address: <span class="txt-primary">( Location / GPS Address )</span></label>
                                    <b-form-textarea
                                      id="textarea"
                                      rows="3"
                                      placeholder="Enter Address"
                                      v-model="patient.address"
                                    ></b-form-textarea> -->
                                    <b-button block  type="submit" :disabled="submitting" variant="primary">Submit</b-button>

                                    <!-- <label class="col-form-label" for="message-text">Message:</label>
                                    <b-form-textarea
                                      id="textarea"
                                      rows="3"
                                    ></b-form-textarea> -->
                                </form>
                            </b-modal>

                            <!-- import patient -->
                            <b-modal id="importPatient" size="lg" title="Import Patients" ok-title="Ok" class="theme-modal">
                              <h5>Choose an Excel file</h5>
                              <p>Choose a <b> .csv, .xls, .xlsx </b> format. File should not exceed <b>0.7MB</b>  must contain not more than <b>3000 records</b></p>
                              <br>
                              <h5>Data presentation below</h5>

                              <table class="table ">
                                <thead>
                                  <th>Patient No</th>
                                  <th>Name</th>
                                  <th>Dob</th>
                                  <th>Gender</th>
                                  <th>Contact</th>
                                  <th>Email</th>
                                  <th>Status</th>
                                  <th></th>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td class=""> <i>PT0001</i></td>
                                    <td> <i>John Doe</i></td>
                                    <td> <i>1990-01-01</i></td>
                                    <td> <i>Male</i></td>
                                    <td> <i>0200000001</i></td>
                                    <td> <i>john.doe@email.com</i></td>
                                    <td> <i>Inactive</i></td>
                                    <td> <i></i></td>
                                  </tr>
                                  <tr>
                                    <td class=""> <i>PT0002</i></td>
                                    <td> <i>John Public</i></td>
                                    <td> <i>1990-01-01</i></td>
                                    <td> <i>Male</i></td>
                                    <td> <i>0200000001</i></td>
                                    <td> <i></i></td>
                                    <td> <i>Active</i></td>
                                    <td> <i></i></td>
                                  </tr>
                                </tbody>
                              </table>
                              <br>
                              <div class="form-group">
                                <h5>Upload Excel file</h5>
                                <vue-dropzone id="singledropzone" :options="singledropzoneOptions" class="dropzone digits" v-on:vdropzone-sending="sendingEvent">                                
                                </vue-dropzone>
                              </div>
                            </b-modal>

                            <!-- view Shop -->
                            <b-modal id="viewShop" ref="viewShopModal" :title="'View Shop : '+viewShop.name" ok-title="Ok" class="theme-modal">
                              <b-table stacked :fields="viewShopfields" :items="[viewShop]">

                                <template #cell(logo)="row">
                                    <figure v-if="row.item.logo" class="b-image-wrapper image is-16by9 m-1">
                                        <a :href="row.item.logo" target="_blank">
                                            <b-img
                                                rounded
                                                :src="row.item.logo"
                                                style="width:40%;"
                                            >
                                            </b-img>
                                        </a>
                                    </figure>
                                </template>

                                <template #cell(active)="row">
                                    <a v-b-tooltip.hover @click="status(row.item)" title="Click to change status" :class="`btn ${ (row.item.active ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ (row.item.active ? 'acive' : 'inactive') }}
                                    </a>
                                </template>

                                <template #cell(shop)="row">
                                  <!-- <div class="txt-primary">
                                  {{ row.item.name }}
                                  </div> -->
                                    <span style="font-weight:500;" class="txt-primary">
                                        {{ row.item.name }} 
                                    </span>
                                    <br>
                                    <a class="txt-dark" target="_blank" :href="`https://www.google.com/maps/search/${row.item.locationName}/${row.item.location.coordinates[0]},${row.item.location.coordinates[1]}?entry=tts`" v-b-tooltip.hover title="View location" style="font-size:0.8rem;"> {{ row.item.locationName }} </a>
                                </template>

                                <template #cell(categories)="row">
                                    <span class="txt-primary" style="font-weight:500">
                                        {{ row.item.categories.join(", ") }}
                                    </span>
                                </template>

                                <template #cell(access)="row">
                                    <div v-b-tooltip.hover :class="`btn ${ (row.item.access[0].status ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" :title="row.item.access[0].type+' : '+new Date(row.item.access[0].updatedAt).toDateString()">
                                    {{ (row.item.access[0].status ? 'granted' : 'pending') }}
                                    </div>
                                </template>

                                <template #cell(email)="row">
                                  <a style="font-weight:500" :href="`mailto:${row.item.email}`" class="txt-primary">
                                      {{ row.item.email }}
                                    </a>
                                </template>

                                <template #cell(phone)="row">

                                    <a style="font-weight:500" :href="`tel:${row.item.phone.countryCode+row.item.phone.tel}`" class="txt-primary">
                                        {{ row.item.phone.countryCode+row.item.phone.tel }}
                                    </a>
                                </template>

                                <template #cell(whatsapp)="row">

                                    <a v-if="row.item.whatsapp" style="font-weight:500" :href="`tel:${row.item.whatsapp.countryCode+row.item.whatsapp.tel}`" class="txt-primary">
                                        {{ row.item.whatsapp.countryCode+row.item.whatsapp.tel }}
                                    </a>
                                </template>

                                <template #cell(ratings)="row">
                                    <span style="font-weight:500" class="txt-primary">
                                        {{ row.item.ratings.length > 0 ? parseFloat(row.item.ratings.reduce((a, b) => a + b, 0) / row.item.ratings.length).toFixed(1) : 0  }}

                                    </span>
                                </template>

                                <template #cell(available)="row">
                                    <div v-b-tooltip.hover  @click="available(row.item)" :class="`btn ${ (row.item.available ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                        {{ (row.item.available ? 'Yes' : 'No') }}
                                    </div>
                                </template>

                                <template #cell(isPickupAvailable)="row">
                                    <div v-b-tooltip.hover :class="`btn ${ (row.item.isPickupAvailable ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                        {{ (row.item.isPickupAvailable ? 'Yes' : 'No') }}
                                    </div>
                                </template>

                                <template #cell(website)="row">

                                    <a v-if="row.item.website" target="_blank" style="font-weight:500" :href="`${row.item.website}`" class="txt-primary">
                                        {{ row.item.website }}
                                    </a>
                                </template>

                                <template #cell(createdAt)="row">
                                      {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                                </template>

                              </b-table>
                            </b-modal>

                          </b-col>
                      </b-row>

                      <b-modal id="visitModal" size="lg" ref="visitModal" :title="'View Visits : '+visitTitle" ok-title="Ok" class="theme-modal">
                              <b-table
                                show-empty
                                ref="orderTable"
                                :items="allVisits"
                                :fields="visitfields"
                                :per-page="perVisitPage"
                              >
                                  <template #cell(username)="row">
                                    <span style="font-weight:500;" class="txt-">
                                      {{ row.item.username }}
                                    </span>
                                </template>
                                
                                <template #cell(user)="row">

                                  <a style="font-weight:500" :href="`tel:${row.item.user.countryCode+row.item.user.tel}`" class="txt-primary">
                                      {{ row.item.user.countryCode+row.item.user.tel }}
                                    </a>
                                </template>

                                <template #cell(comment)="row">

                                  <span style="font-weight:500;" class="txt-primary">
                                    Comment:
                                  </span>
                                  <p>{{ row.item.comment }}</p>

                                  <span style="font-weight:500;" class="txt-primary">
                                    Suggestion:
                                  </span>
                                  <p>{{ row.item.suggestion }}</p>

                                  <span style="font-weight:500;" class="txt-primary">
                                    Response:
                                  </span>
                                  <p>{{ row.item.respons }}</p>

                                </template>

                                <template #cell(rate)="row">

                                  <span style="font-weight:500" class="txt-primary">
                                    {{ row.item.rate }}

                                  </span>
                                </template>

                                <template #cell(createdAt)="row">
                                      {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                                </template>

                                <template #cell(action)="row">

                                  <b-button variant="primary" @click="response(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-reply"> </i> Respond </b-button>

                                </template>
                              </b-table>
                            </b-modal>


                            <b-modal id="qrcodeModel" size="md" ref="qrcodeModel" :title="'View Qr Code : '+qrTitle" ok-title="Ok" class="theme-modal">
                              <img :src="qrfetch" style="width:100%">
                              <!-- <div class="py-2">{{ qrlink }}</div> -->
                               <label class="col-form-label" for="message-text">QR Code: <span class="txt-primary">( Link )</span></label>
                                <b-form-textarea
                                      id="textarea"
                                      rows="4"
                                      placeholder="Enter Address"
                                      v-model="qrlink"
                                ></b-form-textarea>
                            </b-modal>


                            <b-modal id="customerModal" size="lg" ref="customerModal" :title="'View Customer : '+viewCustomer" ok-title="Ok" class="theme-modal">
                              <b-table
                                show-empty
                                ref="orderTable"
                                :items="allCustomers"
                                :fields="customerfields"
                                :per-page="perCustomerPage"
                              >
                                  <template #cell(name)="row">
                                    <span style="font-weight:500;" class="txt-">
                                      {{ row.item.name }}
                                    </span>
                                </template>
                                
                                <template #cell(phone)="row">

                                  <a style="font-weight:500" :href="`tel:${row.item.phone.countryCode+row.item.phone.tel}`" class="txt-primary">
                                      {{ row.item.phone.countryCode+row.item.phone.tel }}
                                    </a>
                                </template>

                                <template #cell(email)="row">

                                    <a v-if="row.item.email" style="font-weight:500" :href="`mailto:${row.item.email}`" class="txt-primary">
                                      {{ row.item.email }}
                                  </a>
                                </template>

                                <template #cell(rate)="row">

                                  <span style="font-weight:500" class="txt-primary">
                                    {{ row.item.rate }}

                                  </span>
                                </template>

                                <template #cell(gender)="row">
                                    <div class="btn btn-primary btn-xs btn-pill mr-3">
                                      {{ row.item.gender }}
                                    </div>
                                </template>

                                <template #cell(createdAt)="row">
                                      {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                                </template>

                                <template #cell(dob)="row">
                                  <span v-if="row.item.dob" v-b-tooltip.hover class="txt-primary" :title="new Date(row.item.dob).toDateString().substr(4)"> {{ calculateAge(row.item.dob) }} years </span>
                                </template>
                              </b-table>
                            </b-modal>
                    <!-- {{ selected }} -->
                      <div class="table-responsive datatable-vue">
                        <b-table
                          show-empty
                          ref="selectableTable"
                          :items="items"
                          :fields="tablefields"
                          :select-mode="selectMode"
                          :sort-by.sync="sortBy"
                          :filter="filter"
                          :current-page="currentPage"
                          :per-page="perPage"
                          @filtered="onFiltered"
                          @row-selected="onRowSelected"
                        >
                          <template #cell(action)="row">
                            <!-- <b-button size="sm" @click="row.toggleDetails" class="mr-2 ">
                              {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                            </b-button> -->
                            <b-dropdown text="more" size="sm" left class="mx-2" menu-class="dropdown-content" variant="primary">
                              <b-dropdown-item @click="visits(row.item)">Visits</b-dropdown-item>
                              <b-dropdown-item @click="products(row.item.name)">Products</b-dropdown-item>
                              <b-dropdown-item @click="customers(row.item.name)">Customers</b-dropdown-item>
                              <b-dropdown-item @click="edit(row.item)">Edit</b-dropdown-item>
                              <b-dropdown-item @click="temp(row.item)">Template</b-dropdown-item>
                              <b-dropdown-item @click="genShopQR(row.item)">Get QR Code</b-dropdown-item>
                              <b-dropdown-divider></b-dropdown-divider>
                              <b-dropdown-item @click="view(row.item)">View </b-dropdown-item>
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="addcomment(row.item)">Add comment</b-dropdown-item> -->
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="viewcomment(row.item.fullname, row.item.tel)">View comment</b-dropdown-item> -->
                              <!-- <b-dropdown-divider></b-dropdown-divider> -->
                              <!-- <b-dropdown-item @click="del(row.index)">Delete </b-dropdown-item> -->
                          </b-dropdown>
                          </template>

                          <template #cell(name)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <span @click="view(row.item)" style="font-weight:500;" class="txt-primary">
                                {{ row.item.name }} 
                              </span>
                              <br>
                              <a class="txt-dark" target="_blank" :href="`https://www.google.com/maps/search/${row.item.locationName}/${row.item.location.coordinates[0]},${row.item.location.coordinates[1]}?entry=tts`" v-b-tooltip.hover title="View location" style="font-size:0.8rem;"> {{ row.item.locationName }} </a>
                          </template>

                          <template #cell(status)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <div v-b-tooltip.hover @click="status(row.item)" title="Click to change status" :class="`btn ${ (row.item.status == 'Active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                {{ row.item.status }}
                              </div>
                          </template>

                          <template #cell(ready)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <div v-b-tooltip.hover @click="available(row.item)" title="Online status" :class="`btn ${ (row.item.ready == 'Yes' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                {{ row.item.ready }}
                              </div>
                          </template>

                          <template #cell(email)="row">

                              <a style="font-weight:500" :href="`mailto:${row.item.email}`" class="txt-primary">
                                {{ row.item.email }}
                             </a>
                          </template>

                          <template #cell(phone)="row">

                            <a style="font-weight:500" :href="`tel:${row.item.phone.countryCode+row.item.phone.tel}`" class="txt-primary">
                                {{ row.item.phone.countryCode+row.item.phone.tel }}
                              </a>
                          </template>

                          <template #cell(rate)="row">

                            <span style="font-weight:500" class="txt-primary">
                              {{ row.item.rate }}

                            </span>
                          </template>

                          <!-- <template #cell(createdAt)="row">
                                {{ row.item.createdAt ? new Date(row.item.createdAt).toDateString().substr(4) : '' }}
                          </template> -->
                        </b-table>
                        
                      </div>

                      <p>{{ totalRows }} items </p>

                      <b-col md="6" class="my-1">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          class="my-0"
                        ></b-pagination>
                      </b-col>
                      


                    </div>

                </div>
              </div>

            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'
import moment from 'moment'
import sha256 from "sha256";

export default {
  data(){
    return{
      singledropzoneOptions:{
          url:"http://localhost:8080/uploadpatient",
          thumbnailWidth: 150,
          maxFiles:1,
          maxFilesize: 0.7,
          addRemoveLinks: true,
          dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Drop file here or click to upload.</h6><span>( Selected file is <strong>uploaded</strong> imediately after selection.)</span>"
      },
      window: null,
      startDisabled: true,
      endDisabled: true,
      img: '',
      pros: [],
      uploadImg: true,
      dropFile: null,
      productFiles: [],
      editShop: false,
      requestLoading: false,
      qrTitle: '',
      qrfetch: null,
      qrlink: '',
      product: {
        product: '',
        discounted: 0,
        category: null,
        tags: '',
        images: '',
        offerType: null,
        price: 0,
        discount: 0,
        type: 'Product',
        start: null,
        end: null,
        expiry: false,
        visible: true,
        limited: false,
        available: true,
        details: '',
        // weight: '',
        // dimensions: {
        //   length: '',
        //   width: '',
        //   height: ''
        // },
      },
      expiry: false,
      viewCustomer: null,
      viewProduct: null,
      editProduct: null,
      allProducts: [],
      allCustomers: [],
      submitting: false,
      visitTitle: '',
      allVisits: [],
      Shop: {
        business: '',
        cat: '',
        email: '',
        password: '',
        phone: {
            countryCode: '',
            tel: ''
        },
        whatsapp: {
            countryCode: '',
            tel: ''
        },
        country: {
            name: '',
            currency: '',
            code: ''
        },
        logo: '',
        type: '',
        website: '',
        locationName: '',
        loc: '',
        active: null,
        address: ''
      },
      slide: 0,
      sliding: null,
      viewShop: {},
      categorySelect: true,
      typeSelect: true,
      codeData: {},
      statusOptions: [
        //   { value: null, text: 'Select ' },
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],
      verifiedOptions: [
        //   { value: null, text: 'Select ' },
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],
      requestOptions:[
        { value:'InApp', item: 'InApp' },
        { value:'OTP', item: 'OTP' }
      ],
      
      // productType: [
      //   { value: null, text: 'Select ' },
      //   { value: 'Item', text: 'Item' },
      //   { value: 'Pack', text: 'Pack' },
      //   { value: 'Bags', text: 'Bags' },
      //   { value: 'Per Weight', text: 'Per Weight' },
      //   { value: 'Per Volume', text: 'Per Volume' }
      // ],
      
      productType: ['Product', 'Service', 'Virtual'],
      offerTypes: ['Promo', 'Discount', 'Multibuy', 'Gift with Purchase', 'Coupon'],
      productCategory: [
        // { value: null, text: 'Select ' },
        // { value: 'Fruit', text: 'Fruit' },
        // { value: 'Vegetable', text: 'Vegetable' },
        // { value: 'Meat', text: 'Meat' },
        // { value: 'Fish', text: 'Fish' },
        // { value: 'Poultry', text: 'Poultry' },
        // { value: 'Diary', text: 'Diary' }
      ],
      tablefields: [
        { key: 'name', label: 'Shop Name', sortable: true, },
        { key: 'status', label: 'Status', sortable: true, },
        { key: 'phone', label: 'Contact', sortable: false, },
        { key: 'type', label: 'Type', sortable: true, },
        { key: 'ready', label: 'Available', sortable: true, },
        // { key: 'locationName', label: 'Location', sortable: true, },
        { key: 'rate', label: 'Rated', sortable: true, },
        { key: 'date', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      viewShopfields: [
        { key: 'logo', label: 'Cover/Logo', sortable: true, },
        { key: 'name', label: 'Shop Name', sortable: true, },
        { key: 'link', label: 'Link', sortable: true, },
        { key: 'active', label: 'Status', sortable: true, },
        { key: 'phone', label: 'Contact', sortable: true, },
        { key: 'whatsapp', label: 'Whatsapp', sortable: true, },
        { key: 'email', label: 'Email', sortable: true, },
        { key: 'type', label: 'Type', sortable: true, },
        { key: 'categories', label: 'Categories', sortable: true, },
        { key: 'available', label: 'Available', sortable: false, },
        { key: 'locationName', label: 'Location', sortable: true, },
        { key: 'ratings', label: 'Rated', sortable: true, },
        { key: 'website', label: 'Website', sortable: true, },
        { key: 'createdAt', label: 'Date', sortable: true, },
      ],
      items: [],
      commentfields: [
        { key: 'body', label: 'Title & Comment', sortable: true, },
        { key: 'date', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      productfields: [
        { key: 'images', label: 'Image', sortable: false, },
        { key: 'product', label: 'Product', sortable: true, },
        { key: 'type', label: 'Type', sortable: true, },
        { key: 'price', label: 'Price', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      visitfields: [
        // { key: 'orderNo', label: 'Order No', sortable: false, },
        // { key: 'shop', label: 'Shop', sortable: true, },
        { key: 'username', label: 'Username', sortable: true, },
        { key: 'user', label: 'Contact', sortable: true, },
        // { key: 'type', label: 'Type', sortable: true, },
        { key: 'rate', label: 'Rate', sortable: true, },
        { key: 'comment', label: 'Feedback', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: false, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      customerfields: [
        { key: 'Name', label: 'Name', sortable: true, },
        { key: 'phone', label: 'Contact', sortable: true, },
        { key: 'email', label: 'Email', sortable: true, },
        // { key: 'type', label: 'Type', sortable: true, },
        { key: 'gender', label: 'Gender', sortable: true, },
        { key: 'dob', label: 'Dob', sortable: true, },
        { key: 'createdAt', label: 'Date', sortable: false, },
      ],
      modes: ['multi', 'single', 'range'],
      filter: null,
      sortBy: 'name',
      selectMode: 'multi',
      selected: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 25, 50, 100],
      sortProductBy: 'product',
      currentProductPage: 1,
      totalProductRows: 1,
      totalCustomerRows: 1,
      perProductPage: 5,
      perCustomerPage: 5,
      totalVisitRows: 1,
      perVisitPage: 5,
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  created() {
    // watch and fetch
    this.$watch(
      () => this.$route.$params,
      () => {
        this.fetchData()
      },
      { immediate: true }

    )

  },
  watch: {
    dropFile() {
        if (this.dropFile !== null ){
            this.img = window.URL.createObjectURL(this.dropFile)    
        }

        if (this.dropFile == null) {
            window.URL.revokeObjectURL(this.img)
        }
    },
    productFiles() {
        if ( this.productFiles.length > 0 ){
            // this.pro = window.URL.createObjectURL(this.productFiles)
            // this.pro = []

            // for (let i = 0; i < this.productFiles.length; i++) {
            //   let el = window.URL.createObjectURL(this.productFiles[i]);
            //   this.pro.push(el)
            // }

            // console.log(this.productFiles)
        }

        if (this.productFiles.length == 0) {
            // window.URL.revokeObjectURL(this.pro)

            for (let i = 0; i < this.productFiles.length; i++) {
              window.URL.revokeObjectURL(this.productFiles[i]);
            }
        }
    },
    whatsapp() {
      if (this.shop.whatsapp.tel !== '') {
        this.shop.whatsapp.countryCode = this.Shop.phone.countryCode
      }
    },
    expiry() {
      if (this.expiry) {
        //
        this.startDisabled = false
        this.endDisabled = false
        this.product.expiry = true
      } else {
        //
        this.startDisabled = true
        this.endDisabled = true
        this.product.expiry = false
      }
    }
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.items.length
    this.window = window
  },
  methods: {
    onSlideStart() {
        this.sliding = true
      },
      onSlideEnd() {
        this.sliding = false
      },
    fetchData() {
      axios.get('/Shop')
        .then(response=>{
          //
          this.items = response.data
          // set
          // (function () {
            for (let index = 0; index < this.items.length; index++) {
                // const element = array[index];
                const rateLen = this.items[index].ratings.length

                if (rateLen > 0) {
                // sum ratings
                const rate = (this.items[index].ratings.reduce((a, b) => a + b, 0)) / rateLen
                // to 2 decimalplaces
                this.items[index].rate = parseFloat(rate.toFixed(1))

                // data.push(data[index])
                } else {
                  this.items[index].rate = 0
                }

                // status
                if (this.items[index].active) {
                  this.items[index].status = 'Active'
                } else {
                  this.items[index].status = 'Inactive'
                }

                // verified
                if (this.items[index].verified) {
                  this.items[index].profile = 'Verified'
                } else {
                  this.items[index].profile = 'Not verified'
                }

                // available
                if (this.items[index].available) {
                  this.items[index].ready = 'Yes'
                } else {
                  this.items[index].ready = 'No'
                }

                // date
                if (this.items[index].createdAt) {
                  this.items[index].date = (new Date(this.items[index].createdAt)).toDateString().substring(4)
                
                }
            }
          // })()

          this.totalRows = this.items.length
        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text:e.response.data,
            type:'error'
          });
        })
    },
    resetProduct() {
        this.allProducts = []
    },
    resetShop() {
      this.editShop = false
      this.dropFile = null
      this.img = null
      this.Shop.name = ''
      this.Shop.website = ''
      this.Shop.isPickupAvailable = ''
      this.Shop.cat = ''
      this.Shop.email = ''
      this.Shop.password = ''
      this.Shop.type = ''
      this.Shop.locationName = ''
      this.Shop.loc = ''
      this.Shop.logo = ''
      this.Shop.active = ''
      this.Shop.phone = {
            countryCode: '',
            tel: ''
      }
      this.Shop.whatsapp = {
            countryCode: '',
            tel: ''
      }
      this.Shop.country = {
            name: '',
            currency: '',
            code: ''
      }
    },
    resetComment() {
      this.comment.editComment = false
      this.comment.patientno = ''
      this.comment.tel = ''
      this.comment.name = ''
      this.comment.title = ''
      this.comment.body = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    sendingEvent (file, xhr, formData) {
        formData.append('paramName', 'some value or other');

        console.log(file)
    },
    successUpload(file, response){
        console.log(file, response)
    },
    failedUpload(file, message, xhr) {
        console.log(file, message, xhr)
    },
    requestPatient(){
      let url = '/patient/request'
      let method = axios.post
      // make uppercase
      this.access.no = this.access.no.toUpperCase()

      // validate
      if ((this.access.no == "" && this.access.tel == "") && (this.access.fullname == "" || this.access.dob == "")){

        this.$swal({
          title:"Warning!",
          text: "Kindly follow Critera for data input!",
          type:'warning'
        });

        return
      }

      this.requestLoading = true

      method(url, this.access)
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          timer: 2000,
          type:'success'
        });

        //
        this.requestLoading = false
        
        //
        this.$refs.requestModal.hide()

        if (this.access.request == "OTP"){
          //
          this.code(this.access)
        }
        
        //
        this.fetchData()

      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });

         //
        this.requestLoading = false

      })

    },
    submitShop(){

      this.submitting = true

      let url
      let method

      if (this.editShop) {
        url = '/shop/'+encodeURIComponent(this.editShop)
        method = axios.patch;

        //
        const loc = this.Shop.loc.split(',')
        this.Shop.location = [ parseFloat(loc[0]), parseFloat(loc[1]) ]
        this.Shop.categories = this.Shop.cat.split(',')

      } else {
        url = '/Shop'
        method = axios.post;
        //
        const loc = this.Shop.loc.split(',')
        this.Shop.location = [ parseFloat(loc[0]), parseFloat(loc[1]) ]
        this.Shop.categories = this.Shop.cat.split(',')

        if (this.allProducts.length > 0) {
            this.Shop.products = this.allProducts
        }
      }

      const cloudURL = 'https://api.cloudinary.com/v1_1/df8hf97qf/image/upload/'
      // upload to cloudinary first
      if (this.dropFile || this.Shop.logo){
          //
          const formData = new FormData()
          formData.append('upload_preset', 'qwwhqvhe')
          formData.append('folder', 'shopnscan/')
          // formData.append('public_id', this.dropFile.name)
          formData.append('file', this.dropFile)

          // check for products
          if (this.Shop.products) {
            //
            const formData = new FormData()
            formData.append('upload_preset', 'qwwhqvhe')
            formData.append('folder', 'shopnscan/products/')
            // upload pro images
            this.Shop.products.forEach( product => {
                // set
                formData.append('file', product.imageFile)
                //
                fetch(cloudURL, {
                    method: 'POST',
                    body: formData
                }).then(async response=> {
                    
                    const data = await response.json()

                    if (!response.ok) {
                        const error = (data && data.message) || response.status
                        return Promise.reject(error)
                    }

                    //
                    product.image = data.secure_url
                    delete(product.imageFile)

                    console.log(product.image)
                    
                })
                
            });

          }

          // 
          if (this.Shop.logo && !this.dropFile) {
            //
            method(url, this.Shop)
                .then(response=>{
                    //
                    this.$swal({
                    title:"Good job!",
                    text: response.data,
                    type:'success'
                    });
                    
                    //
                    this.$refs.ShopModal.hide()
                    //
                    this.fetchData()
                    
                    this.submitting = false

                })
                .catch( e => {
                    this.$swal({
                    title:"Failed!",
                    text: e.response.data,
                    type:'error'
                    });

                    this.submitting = false
                })

            return
          }

          fetch(cloudURL, {
              method: 'POST',
              body: formData
          }).then(async response=> {
                
                const data = await response.json()

                if (!response.ok) {
                    const error = (data && data.message) || response.status
                    return Promise.reject(error)
                }

                //
                this.Shop.logo = data.secure_url

                method(url, this.Shop)
                .then(response=>{
                    //
                    this.$swal({
                    title:"Good job!",
                    text: response.data,
                    type:'success'
                    });
                    
                    //
                    this.$refs.ShopModal.hide()
                    //
                    this.submitting = false
                    //
                    this.fetchData()
                    

                })
                .catch( e => {
                    this.$swal({
                    title:"Failed!",
                    text: e.response.data,
                    type:'error'
                    });

                    this.submitting = false
                })

          })

      }

      
    },
    visits(data) {
        // modal
        this.$refs.visitModal.show()
        //
        this.visitTitle = data.name

        //
        axios.get('/visit/'+data.name).then( response=>{

            //
            this.allVisits = response.data
            this.totalVisitRows = response.data.length

        }).catch(error=>{

            console.log(error.response.data)
        })

    },
    checkSubmit() {
      console.log('here')
      //
      if (this.viewProduct) {
        this.submitProduct()
      } 
      else {
        this.pushProduct()
      }
    },
    pushProduct() {
        //
        const product = {}
        product.product = this.product.product
        product.category = this.product.category
        product.imageFile = this.productFiles
        product.image = ''
        product.tags = this.product.tags
        product.price = parseFloat(this.product.price)
        product.discount = parseInt(this.product.discount)
        product.type = this.product.type
        product.details = this.product.details

        //
        this.allProducts.push(product)
        //
        this.productFiles = null
        // this.product.product = ''
        // this.product.category = null
        // this.product.tags = ''
        // this.product.price = 0
        // this.product.discount = 0
        // this.product.type = null
        // this.product.details = ''
    },
    delproduct(data) {
      //
      // const index = this.allProducts.findIndex(pro => pro.product.includes(row.product))
      // this.allProducts.splice(index, 1)
      //
      this.$swal({
        title: "Delete '"+data.product+"'?",
        text: "Are you sure, You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {

          //
          axios.delete(`/product/${data.shop}/${encodeURIComponent(data.product)}`)
          .then(response=>{
            //
            this.$swal({
              title:`Deleted '${data.product}'!`,
              text: response.data,
              type: 'success'
            })
            // delete image from cloud
            

            //
            this.products(data.shop)
          })
          .catch( e => {
            this.$swal({
              title:"Failed!",
              text: e.response.data,
              type:'error'
            });
          })
          
        }
      })
    },
    editproduct(data){

      this.editProduct = data.product
      //
      const product = {}
      product.shop = data.shop
      product.product = data.product
      product.category = data.category
      product.images = data.images
      product.tags = data.tags
      product.price = data.price
      product.discount = data.discount
      product.type = data.type
      product.start = data.start
      product.end = data.end
      product.visible = data.visible
      product.expiry = data.expiry
      product.limited = data.limited
      product.available = data.available
      product.offerType = data.offerType
      product.details = data.details
      product.description = data.description

      this.product.shop = product.shop
      this.product.product = product.product
      this.product.category = product.category
      this.product.images = product.images
      this.product.tags = product.tags.join(',')
      this.product.price = product.price
      this.product.discount = product.discount
      this.product.type = product.type
      this.product.start = product.start
      this.product.end = product.end
      this.product.visible = product.visible
      this.product.expiry = product.expiry
      this.expiry = product.expiry
      this.product.limited = product.limited
      this.product.available = product.available
      this.product.offerType = product.offerType
      this.product.details = product.details
      this.product.description = product.description
      
      //
      
    },
    products(business) {
        // modal
        this.$refs.productModal.show()
        //
        this.viewProduct = business

        //
        axios.get('/products/'+business).then( response=>{

            //
            this.allProducts = response.data
            this.totalProductRows = response.data.length
            //
            this.productCategory = this.items.find(s=>s.name == business).categories
            // console.log(this.productCategory)

        }).catch(error=>{

            console.log(error.response.data)
        })

    },
    submitProduct() {

        //
        delete(this.product.imageFile)
        this.product.shop = this.viewProduct
        this.product.price = parseFloat(this.product.price)
        this.product.discount = parseFloat(this.product.discount)
        // validate
        // if (this.allProducts.find(pro => pro.product.includes(this.product.product))) {
        //   return
        // }


        //
        let url
        let method

          if (this.editProduct) {
            url = '/product/'+encodeURIComponent(this.editProduct)
            method = axios.patch;

          } else {
            url = '/product'
            method = axios.post;

          }
          //
          method(url, this.product).then(response =>{
            //
            this.$swal({
              title:"Good job!",
              text: response.data,
              type:'success'
            });
            //
            this.products(this.viewProduct)

          }).catch( e => {
              this.$swal({
                title:"Failed!",
                text: e.response.data,
                type:'error'
              });
          })

          if (this.productFiles && this.productFiles.length > 0) {
            
            //
            const cloudURL = 'https://api.cloudinary.com/v1_1/df8hf97qf/image/upload'
            //
            const links = [];
            const product = JSON.parse(JSON.stringify(this.product))
            //
            for (let i = 0; i < this.productFiles.length; i++) {

              const img = this.productFiles[i];

              const formData = new FormData()
              formData.append('upload_preset', 'qwwhqvhe')
              formData.append('folder', 'shopnscan/products/')
              // set
              formData.append('file', img)
              //
              fetch(cloudURL, {
                  method: 'POST',
                  body: formData
              }).then(async response=> {
                          
                const data = await response.json()

                if (!response.ok) {
                    const error = (data && data.message) || response.status

                    this.$swal({
                        title:"Failed!",
                        text: data.message,
                        type:'error'
                    });

                    return Promise.reject(error)
                }

                links.push(data.secure_url);

                // this.product.image = data.secure_url

                if (i == (this.productFiles.length - 1) ) {
                  
                  if (data && links.length > 0) {
                    
                    setTimeout(()=>{ 

                      axios.patch('/product/image/'+encodeURIComponent(product.product), { images: links, shop: product.shop }).then(() =>{
                          //
                          // this.$swal({
                          //   title:"Good job!",
                          //   text: response.data,
                          //   type:'success'
                          // });
                          //
                        this.products(this.viewProduct)

                        this.productFiles = [];

                      }).catch( e => {
                          this.$swal({
                              title:"Failed!",
                              text: e.response.data,
                              type:'error'
                          });
                      })

                    }, 600)
                    
                  }
                }

              })
            }
            
        }
        
        // reset
        this.editProduct = null
        const product = {}
        product.product = ''
        product.category = null
        product.images = []
        product.tags = ''
        product.price = 0
        product.discount = 0
        product.type = 'Product'
        product.start = null
        product.end = null
        product.visible = true
        product.expiry = false
        product.limited = false
        product.available = true
        product.offerType = null
        product.details = ''
        product.description = ''

        this.product = product
            // });
        // }
    },
    submitProducts() {
        //
        const cloudURL = 'https://api.cloudinary.com/v1_1/df8hf97qf/image/upload'
        //
        if (this.products.length > 0) {
            this.products.forEach( product => {
                //
                const formData = new FormData()
                formData.append('upload_preset', 'qwwhqvhe')
                formData.append('folder', 'shopnscan/products/')
                // set
                formData.append('file', product.imageFile)
                //
                fetch(cloudURL, {
                    method: 'POST',
                    body: formData
                }).then(async response=> {
                    
                    const data = await response.json()

                    if (!response.ok) {
                        const error = (data && data.message) || response.status
                        return Promise.reject(error)
                    }

                    //
                    product.image = data.secure_url
                    delete(product.imageFile)

                    console.log(product.image)
                    
                })
                
            });
        }
    },
    customers(shop) {
        // modal
        this.$refs.customerModal.show()
        //
        this.viewCustomer = shop

        //
        axios.get('/users/'+shop).then( response=>{

            //
            this.allCustomers = response.data
            this.totalCustomerRows = response.data.length

        }).catch(error=>{

            console.log(error.response.data)
        })

    },
    edit(data) {
      // modal
      this.$refs.ShopModal.show()
      this.editShop = data.name
      // form
      const Shop = {}
      Shop.name = data.name
      Shop.type = data.type
      Shop.categories = data.categories
      Shop.phone = data.phone
      Shop.email = data.email
      Shop.website = data.website
      Shop.country = data.country
      Shop.active = data.active
      Shop.location = data.location
      Shop.locationName = data.locationName
      Shop.logo = data.logo
      
      if (typeof(data.whatsapp) !== 'undefined') {
        Shop.whatsapp = data.whatsapp
      } else {
        Shop.whatsapp = {
            countryCode: '',
            tel: ''
        }
      }
      
      this.img = data.logo
      this.Shop = Shop
      this.Shop.cat = Shop.categories.join(",")
      this.Shop.loc = Shop.location.coordinates.join(",")

    },
    temp(data) {
      // modal
      this.$refs.ShopModal.show()
      this.uploadImg = false
      // form
      const Shop = {}
      Shop.name = data.name
      Shop.type = data.type
      Shop.categories = data.categories
      Shop.phone = data.phone
      Shop.email = data.email
      Shop.website = data.website
      Shop.country = data.country
      Shop.active = data.active
      Shop.location = data.location
      Shop.locationName = data.locationName
      Shop.logo = data.logo
      
      if (typeof(data.whatsapp) !== 'undefined') {
        Shop.whatsapp = data.whatsapp
      } else {
        Shop.whatsapp = {
            countryCode: '',
            tel: ''
        }
      }
      
      this.img = data.logo
      this.Shop = Shop
      this.Shop.cat = Shop.categories.join(", ")
      this.Shop.loc = Shop.location.coordinates.join(",")

    },
    genShopQR(data){
      //
      // generateShopHash: (state) => (name) => {
            const secret = 225466879314
            
            //
            const base = "https://app.shopnscan.app/"
            const secured = sha256(data.link+secret)
            const link = `${base}?shop=${data.link}&secured=${secured}`

            const qr = `https://api.qrserver.com/v1/create-qr-code/?size=800x800&data=${encodeURIComponent(link)}`

            // return link
            // alert(link)
            // this.$swal({
              // title:`QR Link - ${data.name}`,
              // text: link,
              // type:'success'
            // });

            this.qrTitle = data.name
            this.qrfetch = qr
            this.qrlink = link

            this.$refs.qrcodeModel.show()

        // }
    },
    view(data){
      // modal
      this.$refs.viewShopModal.show()

      this.viewShop = data
      //
    },
    status(data) {
      //
      axios.post('/shop/status', { name: data.name, phone: data.phone, status: data.active })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    available(data) {
      //
      axios.post('/shop/available', { name: data.name, phone: data.phone, available: data.available })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    del(data) {

      this.$swal({
				text:`Are you sure you want to delete ${data.name}'s request?`,
				showCancelButton: true,
				confirmButtonText: 'Yes',
        type:'error'
			}).then((result)=>{

        if(result.value){

          axios.delete('/patient/request/'+data.patientno+'/'+data.access[0]._id)
            .then(response=>{
              //
              this.$swal({
                title:"Good job!",
                text: response.data,
                type:'success'
              });
              //
              this.fetchData()
            })
            .catch( e => {
              this.$swal({
                title:"Failed!",
                text: e.response.data,
                type:'error'
              });
          })
        }
      })
    },
    calculateAge(dob) { 
      //
      let now
      now = moment(new Date())
      const _dob = moment(dob)
      return now.diff(_dob, 'years')
    },
    formatPrice(price) {
        return price.toFixed(2)
    },
    getDiscount(price, disc) {
            return ((100 - disc)/100) * price;
    },
    onSelect({name, iso2, dialCode}) {
        // this.form.code = "+"+dialCode
        this.Shop.country.name = name.split("(")[0].trim()
        this.Shop.country.currency = dialCode == "233" ? iso2+"₵" : iso2
        this.Shop.country.code = dialCode
        this.Shop.phone.countryCode = dialCode
        console.log(name, iso2, dialCode);
    },
    switchCategory() {
        this.categorySelect = this.categorySelect ? false : true
    },
    switchType() {
        this.typeSelect = this.typeSelect ? false : true
    },
    sameAsWhatsapp() {
      this.Shop.whatsapp = this.Shop.phone
    },
    switchUploadImg() {
      this.uploadImg = this.uploadImg ? false : true
    },
    checkDiscount() {
      this.product.offerType = this.product.discount > 0 ? 'Discount' : null
      this.product.discounted =  (Math.round(((100 - this.product.discount)/100) * this.product.price) * 1000)/1000;
    },
    genDiscount () {
        const dd = ((this.product.price - this.product.discounted) / this.product.price) * 100;

        this.product.discount = (Math.round(dd * 1000))/1000
    }
  }
}
</script>
<style scoped>
/* #patientForm .form-control {
 font-size: inherit;
} */

.table tr > td {
  color: rgba(43,43,43,.54);
}

.loader-box [class*="loader-"] {
    width: 30px;
    height: 30px;
}
</style>